import { useEffect } from "react";
import Button from "../../components/Button";

export default function Audit() {
  useEffect(() => {
    document.title = "Audit - Aldebaran";
  }, []);

  const results = [
    {
      title: "Smart Contracts",
      body: "Core staking, vault, and DREAM token contracts reviewed line by line. No critical or high-severity findings. Two informational notes on gas usage were resolved before publication.",
    },
    {
      title: "Reward & Rebase Logic",
      body: "Auto-compounding math and the rebase schedule were checked for rounding drift and overflow. Reward accounting is consistent across epochs with no value leakage.",
    },
    {
      title: "Treasury & Multisig",
      body: "Treasury inflows and outflows are gated behind a 3-of-5 multisig. Spending paths were traced and confirmed to require quorum on every transfer.",
    },
    {
      title: "Access Control",
      body: "Privileged roles, upgrade hooks, and admin entry points were enumerated. One medium-severity ownership concern was identified and fixed during the engagement.",
    },
  ];

  return (
    <div className="page">
      <div className="page__container">
        <header className="page__hero">
          <p className="page__eyebrow">Security</p>
          <h1 className="page__title">Audited and verified</h1>
          <p className="page__lead">
            The Aldebaran protocol was independently audited by Sentinel Labs in
            September 2024, covering every contract behind auto-staking and
            auto-compounding.
          </p>
          <span className="page__badge page__badge--pass">
            Passed - no critical issues
          </span>
        </header>

        <section className="page__section">
          <h2>Scope</h2>
          <div className="page__prose">
            <p>
              The engagement covered the full on-chain surface of the protocol
              on TON. Reviewers had access to source code, deployment scripts,
              and the test suite, and reproduced each contract from source.
            </p>
            <ul>
              <li>Smart contracts: staking vault, DREAM token, and router.</li>
              <li>Reward and rebase logic, including epoch accounting.</li>
              <li>Treasury flows and the multisig spending policy.</li>
              <li>Access control, role assignment, and upgrade paths.</li>
            </ul>
          </div>
        </section>

        <section className="page__section">
          <h2>Results by area</h2>
          <div className="page__grid">
            {results.map((item) => (
              <article className="page__card" key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="page__section">
          <h2>Findings summary</h2>
          <div className="page__prose">
            <p>
              Across the engagement the auditors recorded zero critical and zero
              high-severity issues. One medium-severity finding in access control
              and three informational notes were raised, and all four were
              resolved and re-verified before the final report.
            </p>
            <p>
              Final tally: 0 critical, 0 high, 1 medium (resolved), 3
              informational (resolved). The deployed contracts match the audited
              commit.
            </p>
          </div>
        </section>

        <div className="page__cta">
          <Button to="/documents" variant="ghost" className="btn--lg">
            Back to documents
          </Button>
          <Button to="/instructions" className="btn--lg">
            Get started
          </Button>
        </div>
      </div>
    </div>
  );
}
